import { render, staticRenderFns } from "./BookingForms.vue?vue&type=template&id=231defd1&"
import script from "./BookingForms.vue?vue&type=script&lang=js&"
export * from "./BookingForms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports